var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPageview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.36,
    height: 11.36,
    viewBox: "0 0 11.36 11.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "search_FILL0_wght400_GRAD0_opsz48",
    d: "M16.666,17.31l-4.15-4.15a3.477,3.477,0,0,1-1.1.639,4.094,4.094,0,0,1-4.228-.955A3.892,3.892,0,0,1,6,9.989,4.04,4.04,0,0,1,10.055,5.95,3.866,3.866,0,0,1,12.9,7.133a4.038,4.038,0,0,1,.955,4.165,4,4,0,0,1-.663,1.183l4.165,4.134Zm-6.611-4.228a2.953,2.953,0,0,0,2.177-.907,3.1,3.1,0,0,0,0-4.37A2.953,2.953,0,0,0,10.055,6.9,3.1,3.1,0,0,0,6.947,9.989a3.1,3.1,0,0,0,3.108,3.092Z",
    transform: "translate(-6 -5.95)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageview);
export default __webpack_public_path__ + "static/media/pageview.161341580c1eb4098cba36f7f6663942.svg";
export { ForwardRef as ReactComponent };